export default {
  path: 'winter-service/v2/work-orders/overview',
  name: 'WinterService2WorkOrdersOverview',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/WorkOrdersOverviewIndex.vue')
}
